export default "__VITE_ASSET__CY_48YNX__"